import "./MapText.scss";

export default function MapText(props: { lat: number; lng: number }) {
  return <p className="mapText">First Free Will Baptist of Waverly</p>;
}
